import {createAction, handleActions} from 'redux-actions';
import {Api} from '../../api/api';
import _ from 'lodash';
import {NOTIFICATION_TYPES} from "../../constants/constants";
import {getGroupsForSubRole, getSubRoles, SUB_ROLES} from "../account/role";
import {logout, onForbidden} from "../account/login";
import {CONSENT_REQUESTS_FILTER} from "../consent/organizationConsents";
import { StorageApi } from '../../utils/storageApi';
import { getKey } from '../accreditation/certificate';
import { isAccreditationSigningRequired } from '../organization/organization';

//- Actions
export const fetchGetNotificationFailed = createAction('FETCH_GET_NOTIFICATIONS_FAILED');
export const clearState = createAction('CLEAR_STATE');


export const getSysAdminNotifications = () => (dispatch, getState) => {
    dispatch(clearState());
    dispatch(fetchGetPendingOrganizationsNotification());
    dispatch(fetchGetOrgsWithoutCertificatesNotification());
    let subRoles = getSubRoles(getState());
    if (subRoles.includes(SUB_ROLES.ROOT) || subRoles.includes(SUB_ROLES.PA)) {
        dispatch(fetchGetUnreferencedAccreditationRequestsByDomainsNotification());
        dispatch(fetchGetGlobalCertificatesNotification());
    }
};


export const fetchGetUnreferencedAccreditationRequestsByDomainsNotificationSuccess = createAction('FETCH_GET_NOTIFICATIONS_SUCCESS', (data) => ({
    data: data,
    type: NOTIFICATION_TYPES.UNREFERENCED_ACCREDITATION_REQUESTS_BY_DOMAINS
}));
export const fetchGetUnreferencedAccreditationRequestsByDomainsNotification = createAction(
    'FETCH_GET_NOTIFICATION',
    () => Api.getAccreditationRequestsByDomains(false),
    () => ({
        apiCall: true,
        onSuccess: fetchGetUnreferencedAccreditationRequestsByDomainsNotificationSuccess,
        onFail: fetchGetNotificationFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchGetPendingOrganizationsNotificationSuccess = createAction('FETCH_GET_NOTIFICATIONS_SUCCESS', (data) => ({
    data: data,
    type: NOTIFICATION_TYPES.PENDING_ORGANIZATIONS
}));
export const fetchGetPendingOrganizationsNotification = createAction(
    'FETCH_GET_NOTIFICATION',
    () => Api.getOrgs(false),
    () => ({
        apiCall: true,
        onSuccess: fetchGetPendingOrganizationsNotificationSuccess,
        onFail: fetchGetNotificationFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchGetGlobalCertificatesNotificationSuccess = createAction('FETCH_GET_NOTIFICATIONS_SUCCESS', (data) => ({
    data: { length: _.isNil(data) || data.length === 0 ? 1 : 0 },
    type: NOTIFICATION_TYPES.ADMIN_SECURITY_NOTIFICATIONS
}));
export const fetchGetGlobalCertificatesNotification = createAction(
    'FETCH_GET_NOTIFICATION',
    () => Api.getGlobalCertificates(),
    () => ({
        apiCall: true,
        onSuccess: fetchGetGlobalCertificatesNotificationSuccess,
        onFail: fetchGetNotificationFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchGetOrgsWithoutCertificatesNotificationSuccess = createAction('FETCH_GET_NOTIFICATIONS_SUCCESS', (data) => ({
    data: data,
    type: NOTIFICATION_TYPES.ADMIN_SECURITY_NOTIFICATIONS
}));
export const fetchGetOrgsWithoutCertificatesNotification = createAction(
    'FETCH_GET_NOTIFICATION',
    () => Api.getOrgsWithoutCertificates(),
    () => ({
        apiCall: true,
        onSuccess: fetchGetOrgsWithoutCertificatesNotificationSuccess,
        onFail: fetchGetNotificationFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchGetInsertorNotifications = () => (dispatch, getState) => {
    dispatch(clearState());
    let groups = getGroupsForSubRole(getState());
    _.map(groups, group => {
        dispatch(fetchGetReviewFailedAccreditationsNotification(group.id, true));
        dispatch(fetchGetReviewFailedAccreditationsNotification(group.id, false));
        dispatch(fetchGetPendingAccreditationRequestsNotification(group.id))
    });
    let key = getKey(getState());
    let accreditationSigningRequired = isAccreditationSigningRequired(getState());
    dispatch(addNotificationData({ type: NOTIFICATION_TYPES.INSERTER_SECURITY_NO_CERTIFICATE, value: !accreditationSigningRequired || !_.isNil(key) ? 0 : 1 }));
};

export const fetchGetPendingAccreditationRequestsNotificationSuccess = createAction('FETCH_GET_NOTIFICATIONS_SUCCESS', (data) => ({
    data: data,
    type: NOTIFICATION_TYPES.PENDING_ACCREDITATION_REQUESTS
}));
export const fetchGetPendingAccreditationRequestsNotification = createAction(
    'FETCH_GET_NOTIFICATION',
    (groupId) => Api.getPendingAccreditationRequests(groupId, null),
    () => ({
        apiCall: true,
        onSuccess: fetchGetPendingAccreditationRequestsNotificationSuccess,
        onFail: fetchGetNotificationFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchGetReviewFailedAccreditationsNotificationSuccess = createAction('FETCH_GET_NOTIFICATIONS_SUCCESS', (data) => ({
    data: data,
    type: NOTIFICATION_TYPES.REVIEW_FAILED_ACCREDITATIONS
}));
export const fetchGetReviewFailedAccreditationsNotification = createAction(
    'FETCH_GET_NOTIFICATION',
    (groupId, isInternal) => Api.getAccreditationsForReviewByGroupId(groupId, 0, isInternal),
    () => ({
        apiCall: true,
        onSuccess: fetchGetReviewFailedAccreditationsNotificationSuccess,
        onFail: fetchGetNotificationFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchGetValidatorNotifications = () => (dispatch, getState) => {
    dispatch(clearState());
    let groups = getGroupsForSubRole(getState());
    _.map(groups, group => {
        dispatch(fetchGetValidateAccreditationsNotification(group.id));
    })
};
export const fetchGetValidateAccreditationsNotificationSuccess = createAction('FETCH_GET_NOTIFICATIONS_SUCCESS', (data) => ({
    data: data,
    type: NOTIFICATION_TYPES.VALIDATE_ACCREDITATIONS
}));
export const fetchGetValidateAccreditationsNotification = createAction(
    'FETCH_GET_NOTIFICATION',
    (groupId) => Api.getAccreditationsForValidation(groupId),
    () => ({
        apiCall: true,
        onSuccess: fetchGetValidateAccreditationsNotificationSuccess,
        onFail: fetchGetNotificationFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const getApplicantNotifications = () => (dispatch) => {
    dispatch(clearState());
    dispatch(fetchGetPendingAccreditationsNotification());
    dispatch(fetchGetPendingConsentsNotification());
};
export const fetchGetPendingAccreditationsNotificationSuccess = createAction('FETCH_GET_NOTIFICATIONS_SUCCESS', (data) => ({
    data: data,
    type: NOTIFICATION_TYPES.PENDING_ACCREDITATIONS
}));
export const fetchGetPendingAccreditationsNotification = createAction(
    'FETCH_GET_NOTIFICATION',
    () => Api.getPendingAccreditations(),
    () => ({
        apiCall: true,
        onSuccess: fetchGetPendingAccreditationsNotificationSuccess,
        onFail: fetchGetNotificationFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const addNotificationData = createAction('ADD_NOTIFICATION_DATA');

export const getAnchorNotifications = () => (dispatch) => {
    dispatch(clearState());
    dispatch(fetchGetUnreferencedAccreditationRequestsByAGsNotification());

    let anchorSecurityGotIt = StorageApi.getAnchorSecurityGotIt();
    dispatch(addNotificationData({ type: NOTIFICATION_TYPES.ANCHOR_SECURITY_GOT_IT, value: anchorSecurityGotIt ? 0 : 1 }));
};
export const fetchGetUnreferencedAccreditationRequestsByAGsNotificationSuccess = createAction('FETCH_GET_NOTIFICATIONS_SUCCESS', (data) => ({
    data: data,
    type: NOTIFICATION_TYPES.UNREFERENCED_ACCREDITATION_REQUESTS_BY_AGS
}));
export const fetchGetUnreferencedAccreditationRequestsByAGsNotification = createAction(
    'FETCH_GET_NOTIFICATION',
    () => Api.getAccreditationRequestsByAGs(),
    () => ({
        apiCall: true,
        onSuccess: fetchGetUnreferencedAccreditationRequestsByAGsNotificationSuccess,
        onFail: fetchGetNotificationFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchGetPendingConsentsNotificationSuccess = createAction('FETCH_GET_NOTIFICATIONS_SUCCESS', (data) => ({
    data: data,
    type: NOTIFICATION_TYPES.PENDING_CONSENTS
}));
export const fetchGetPendingConsentsNotification = createAction(
    'FETCH_GET_NOTIFICATION',
    () => Api.getRequestsByStatus(CONSENT_REQUESTS_FILTER.PENDING),
    () => ({
        apiCall: true,
        onSuccess: fetchGetPendingConsentsNotificationSuccess,
        onFail: fetchGetNotificationFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchGetRejectedAccreditationsNotifications = (groupId) => (dispatch) => {
    dispatch(clearState());
    dispatch(fetchGetRejectedByApplicantsAccreditationsNotification(groupId));
    dispatch(fetchGetRejectedByValidatorsAccreditationsNotification(groupId, false));
};

export const fetchGetRejectedByApplicantsAccreditationsNotificationSuccess = createAction('FETCH_GET_NOTIFICATIONS_SUCCESS', (data) => ({
    data: data,
    type: NOTIFICATION_TYPES.REJECTED_BY_APPLICANTS_ACCREDITATIONS
}));
export const fetchGetRejectedByApplicantsAccreditationsNotification = createAction(
    'FETCH_GET_NOTIFICATION',
    (groupId) => Api.getAccreditationsForReviewByGroupId(groupId, 0, false),
    () => ({
        apiCall: true,
        onSuccess: fetchGetRejectedByApplicantsAccreditationsNotificationSuccess,
        onFail: fetchGetNotificationFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchGetRejectedByValidatorsAccreditationsNotificationSuccess = createAction('FETCH_GET_NOTIFICATIONS_SUCCESS', (data) => ({
    data: data,
    type: NOTIFICATION_TYPES.REJECTED_BY_VALIDATORS_ACCREDITATIONS
}));
export const fetchGetRejectedByValidatorsAccreditationsNotification = createAction(
    'FETCH_GET_NOTIFICATION',
    (groupId) => Api.getAccreditationsForReviewByGroupId(groupId, 0, true),
    () => ({
        apiCall: true,
        onSuccess: fetchGetRejectedByValidatorsAccreditationsNotificationSuccess,
        onFail: fetchGetNotificationFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

//- State
const initialState = {
    data: null,
    error: null,
    fetching: false
};

//- Reducers
export default handleActions({
    FETCH_GET_NOTIFICATION: (state) => {
        return {...state, error: null, fetching: true};
    },
    FETCH_GET_NOTIFICATIONS_FAILED: (state, action) => {
        return {...state, error: action.payload, fetching: false};
    },
    FETCH_GET_NOTIFICATIONS_SUCCESS: (state, action) => {
        let currentValue = (state.data && state.data[action.payload.type] ? state.data[action.payload.type] : 0);
        let nextValue = currentValue + (!_.isNil(action.payload.data.totalElements) ? action.payload.data.totalElements : action.payload.data.length);
        return {
            ...state,
            data: {
                ...state.data,
                [action.payload.type]: nextValue
            },
            error: null,
            fetching: false
        };
    },
    ADD_NOTIFICATION_DATA: (state, action) => {
        return {
            ...state,
            data: {
                ...state.data,
                [action.payload.type]: action.payload.value
            }
        };
    },
    CLEAR_STATE: (state) => {
        return {...state, data: null};
    }

}, initialState);


//- Selectors
export const getNotifications = state => state.notifications;

export const loadingNotifications = state => getNotifications(state).fetching;

export const getNotificationsData = state => getNotifications(state).data;



// WEBPACK FOOTER //
// ./src/reducers/common/notifications.js